// Utility to persist favorite comitente in localStorage

const FAVORITE_KEY = "favorite_comitente";

const getStorageKey = (email: string): string => {
  return `${email}_${FAVORITE_KEY}`;
};

export const getFavoriteAccount = ({
  email,
}: {
  email: string;
}): string | null => {
  try {
    const value = localStorage.getItem(getStorageKey(email));
    return value || null;
  } catch (e) {
    // localStorage may be unavailable in some environments
    return null;
  }
};

export const setFavoriteAccount = ({
  accountNumber,
  email,
}: {
  accountNumber: string | null;
  email: string;
}) => {
  if (accountNumber) {
    localStorage.setItem(getStorageKey(email), accountNumber);
  } else {
    localStorage.removeItem(getStorageKey(email));
  }
};

export default {
  getFavoriteAccount,
  setFavoriteAccount,
};
